<template>
    <div class="row accordion-item" :class="{ 'active': open, 'is-desktop': isDesktop }">
        <div class="col-md-10 offset-md-1">
            <button class="accordion-title mb-0 virtual-h3" @keydown.esc="open = false" @click="open = !open"
                    :aria-expanded="open ? 'true' : 'false'" v-if="!isDesktop">
                <slot name="title"></slot>
            </button>
            <h2 class="accordion-title mb-0 virtual-h3" v-if="isDesktop">
                <slot name="title"></slot>
            </h2>

            <div class="accordion-content">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Accordion",

    props: {
        isDesktopOpen: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            open: false
        }
    },

    computed: {
        isDesktop() {
            return window.matchMedia('(min-width: 768px)').matches;
        }
    },

    created() {
        if (this.isDesktop) {
            this.open = true;
        }
    }
}
</script>
